import type { ReactNode } from "react"
import React, { useEffect, useRef, useState } from "react"
import BalanceText from "balance-text"
import { useSegment } from "tracking"
import { CountdownTimer } from "./Countdown/Countdown"
import { bannerContainer } from "./SkinnyBanner.css"

interface Props {
  href: string
  children: ReactNode | ReactNode[]
  expirationDate?: string
  backgroundColor?: string
}

export const SkinnyBanner: React.FC<Props> = ({
  href,
  children,
  expirationDate,
  backgroundColor,
}) => {
  const [opacity, setOpacity] = useState(0)

  const ref = useRef(null)
  const { track } = useSegment()
  useEffect(() => {
    if (!ref.current) return
    BalanceText(ref.current, { watch: true })
    setOpacity(1)
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      BalanceText(ref.current, { watch: false })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current])

  const handleClick = () => {
    track({
      event: "Page Element Clicked",
      properties: {
        module_content: "Skinny Banner",
        module_content_url: href,
      },
    })
  }

  return (
    <div
      data-testid="SkinnyBanner"
      className={bannerContainer}
      style={{ backgroundColor }}
    >
      <a
        href={href}
        ref={ref}
        onClick={handleClick}
        style={{
          opacity,
          transition: `${opacity} 0.3s ease-in-out`,
        }}
      >
        {children}
      </a>
      {expirationDate && <CountdownTimer targetDate={expirationDate} />}
    </div>
  )
}
